import { useDynamicConfig } from "@statsig/react-bindings";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { featureFlag } from "@/context/FeatureFlagProvider/featureFlags";

export const useModuleEndpoint = (moduleName: string) => {
  const location = useLocation();
  const { value: dynamicModuleControl } = useDynamicConfig(featureFlag.dynamicModuleControl);

  return useMemo(() => {
    const pathname = location.pathname;

    // Check for version override first
    if (pathname.includes("/v1")) {
      return "old";
    }

    if (pathname.includes("/v2")) {
      return "new";
    }

    // Use feature flag for base routes
    const modules = (dynamicModuleControl as any)?.modules || [];
    const isModuleEnabled = Array.isArray(modules) && modules.includes(moduleName);

    return isModuleEnabled ? "new" : "old";
  }, [dynamicModuleControl, location.pathname, moduleName]);
};
